import React from 'react'
import './HowitsworkComponent.css'
import { BsCheckAll } from "react-icons/bs";


const HowitsworkComponent = () => {
    return (
        <>
            <div className="banner_section" style={{flex:"1"}}>
                <div>
                    <div className="how_to_work">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-12 col-sm-12 mb_commn_pd_0">
                                    <h3>How It Works</h3>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="work_process">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 mb_commn_pd_0 how_it_work">
                                    <h4 className="common_heading">User Registration Process</h4>
                                    <ul>
                                        <li><span><BsCheckAll className="check_icon" />
                                        </span>Welcome to Shop Saverz. Sign in using your Gmail account by clicking the login button.</li>
                                        <li>
                                            <span><BsCheckAll className="check_icon" /></span> Upon successful login, you will receive a bonus of 200 points.</li>
                                        <li>
                                            <span><BsCheckAll className="check_icon" /></span>Navigate to the banners section to view all products and their banners.</li>
                                        <li>
                                            <span><BsCheckAll className="check_icon" /></span>Claim your accumulated points by clicking on the button on the right side, which are replenished every 4 hours.</li></ul>


                                    <h4 className="common_heading ">Bidding Process</h4>
                                    <ul>
                                        <li><span><BsCheckAll className="check_icon" /></span>Place bids on products of interest from the available listings.</li>
                                        <li><span><BsCheckAll className="check_icon" /></span>Explore other Affiliate Partners' products listed below the current auction.</li>
                                        <li><span><BsCheckAll className="check_icon" /></span>After scrolling down, Discover our top Affiliate Partners, exclusive benefactors, and top winners on the platform.</li>
                                        <li><span><BsCheckAll className="check_icon" /></span>View product listings displaying the product name and time remaining for bidding closure.</li></ul>

                                    <h4 className="common_heading">Purchasing Process</h4>
                                    <ul>
                                        <li><span><BsCheckAll className="check_icon" /></span>Access the cart section anytime to manage and update your bids.</li>
                                        <li><span><BsCheckAll className="check_icon" /></span>Utilize the dropdown menu on the card's right side to access features like Profile Edit, Winners, Wallet, Banner Queries, Referral, Copy Referral Link, and Logout.</li>
                                        <li><span><BsCheckAll className="check_icon" /></span>Review your points history by selecting the Points History option.</li>
                                        <li><span><BsCheckAll className="check_icon" /></span>Obtain your unique Referral Code to share with friends and family for earning 100 points per successful referral.</li></ul></div>

                                <div className="col-lg-4 mb_commn_pd_0">
                                    <iframe width="100%" height="300" src="https://www.youtube.com/embed/1xsQZqx8Fq0?rel=0" title="Discover How Shop Saverz Works for a User! 🤔" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe></div></div>

                            <div className="row">
                                <div className="col-lg-12 mb_commn_pd_0">
                                    <hr />
                                </div>
                            </div>
                            <div className="row vender_how_work_section">
                                <div className="col-lg-8 mb_commn_pd_0 how_it_work">
                                    <h4 className="common_heading">Affiliate Partner Registration Process</h4>
                                    <ul>
                                        <li><span><BsCheckAll className="check_icon" /></span>To become a affiliate partner, check the box labeled "If you want to become a Affiliate Partner".</li>
                                        <li><span><BsCheckAll className="check_icon" /></span> Fill in the
                                            details, including Business Name, Business GST, and select a banner of the specified size.
                                        </li>
                                        <li><span><BsCheckAll className="check_icon" /></span>Click the "Apply For Affiliate Partner" button once the banner is adjusted.</li>
                                        <li><span><BsCheckAll className="check_icon" /></span>Your Affiliate Partner request will be assigned a token number and forwarded for approval.
                                        </li></ul></div>
                                <div className="col-lg-4 mb_commn_pd_0">
                                    <iframe width="100%" height="300" src="https://www.youtube.com/embed/ky8JyrEbxCY?rel=0" title="Learn Vendor Registration Process 😎" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe></div></div></div></div></div></div>

        </>
    )
}

export default HowitsworkComponent
